import { CustomPriceListStatusCountsRecord } from '../types/pricing';

import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export const customPriceListStatusCountsQueryAtom = createQueryAtomFactory(
  'brokerage.customPriceListStatusCounts',
  () => ({
    customPriceListStatusCounts: {
      active: true,
      expired: true,
      archived: true,
      draft: true,
    },
  }),
  {
    select: (data): CustomPriceListStatusCountsRecord => {
      const counts = data?.customPriceListStatusCounts;
      return {
        active: counts?.active ?? 0,
        expired: counts?.expired ?? 0,
        archived: counts?.archived ?? 0,
        draft: counts?.draft ?? 0,
      };
    },
  },
);
